import React from 'react';
import { Card, CardContent, CardActions, Grid, Typography, Button } from '@mui/material';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const MaskedCard = (props) => {
  const { cardDetails, headerText, onClickAddNewCard } = props;
  const { t } = useTranslation();
  const isNotPrepended = cardDetails?.maskedCardNumber?.match(/^[0-9]+$/);

  return (
    <>
      <Card className={classNames(['maskData', 'customCardWraper'])} sx={{ minWidth: 275 }}>
        {/* {headerText && <CardHeader titleTypographyProps={{ variant: 'h6' }} title={headerText} />} */}
        <CardContent className="cardContents">
          {headerText && <Typography variant="h6">{headerText}</Typography>}
          {cardDetails?.accountType && <Typography variant="subtitle1">{cardDetails?.accountType}</Typography>}
          {cardDetails?.maskedCardNumber && (
            <Typography variant="body">
              {isNotPrepended ? 'ending in ' : ''}
              {cardDetails?.maskedCardNumber}
            </Typography>
          )}
          <Grid></Grid>
        </CardContent>
        {typeof onClickAddNewCard === 'function' && (
          <CardActions>
            <Button
              id="AddNewCard"
              type="button"
              variant="contained"
              color="secondary"
              className={'addNewCardBtn'}
              onClick={(e) => onClickAddNewCard(e)}
            >
              {t('addAnotherCard')}
            </Button>
          </CardActions>
        )}
      </Card>
    </>
  );
};

MaskedCard.propTypes = {
  cardDetails: PropTypes.shape({
    accountType: PropTypes.string,
    maskedCardNumber: PropTypes.string,
  }),
  headerText: PropTypes.string,
  onClickAddNewCard: PropTypes.func,
};

export default MaskedCard;
